<div
  class="ux-board"
  #boardRoot
  [ngClass]="isLightTheme ? 'ux-light-background' : 'ux-dark-background'"
>
  <div class="ux-title uk-padding ux-title-row" style="padding-top: 0">
    <div class="ux-title-main">
      <div *ngIf="depatures?.length > 0">
        <span>Departures </span>
        <span class="ux-title-direction" *ngIf="directionFilter"
          >{{ directionFilter }}bound</span
        >
        <span
          class="ux-title-direction"
          *ngIf="directionFilter == false && showStopName"
          >{{ busStop[1] }}</span
        >
      </div>
    </div>
    <div class="ux-title-clock">
      {{ today | date : "HH:mm" }}
    </div>
  </div>

  <div *ngIf="depatures?.length > 0 && !dataStale; else inactive" @fade>
    <div class="uk-padding uk-padding-remove-top">
      <table class="uk-table ux-table">
        <thead>
          <tr>
            <th class="ux-width-line">Line</th>
            <th class="ux-width-direction">Direction</th>
            <th class="ux-width-stand"><span *ngIf="showStand">Stand</span></th>
            <th class="ux-width-time">Depature in</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let depature of depatures">
            <td>
              <div
                class="ux-bus ux-line-{{ depature?.line }}"
                [ngClass]="{
                  'ux-bus-compact': depature?.line?.length > 3,
                  'ux-bus-tight': depature?.line?.length > 5
                }"
              >
                {{ depature?.line }}
              </div>
            </td>

            <td>
              {{ depature?.destination[0]
              }}<span
                *ngIf="depature?.destination?.length > 1"
                class="ux-via-destination-wrap"
              >
                <span
                  *ngIf="depature?.destination?.length > 1"
                  class="ux-via-destination"
                  >, {{ depature?.destination[1] }}</span
                >
              </span>
            </td>
            <td>
              <span *ngIf="showStand">{{ depature?.stand }}</span>
            </td>
            <td>
              <div
                class="ux-departure-time"
                *ngFor="let time of depature?.time; let i = index"
                [ngClass]="{ delayed: time.isDelayed === true }"
              >
                <div class="ux-time">
                  <span class="ux-time">{{ time.depatureInMin }}</span>
                  <span class="ux-time-status" *ngIf="time.isLive">●</span>
                </div>
                <span class="ux-time-decorator">
                  <span *ngIf="time.depatureInMin != 'now'">mins</span>
                </span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <ng-template #inactive>
    <div class="uk-animation-fade" style="animation-delay: 5000ms">
      <div class="ux-inactive">
        <div class="ux-text-large uk-grid">
          <div class="uk-width-2-3">Cannot display information.</div>
        </div>
        <div class="ux-text-regular uk-grid">
          <div class="uk-width-2-3">
            Please refer to bus timetables on boards, or via the Stagecoach App.
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- Message Box -->
  <div class="ux-message-box" [ngClass]="{ hidden: !activeMessage }">
    <div class="ux-info-icon">
      <svg
        fill="white"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xml:space="preserve"
        version="1.1"
        style="
          shape-rendering: geometricPrecision;
          text-rendering: geometricPrecision;
          image-rendering: optimizeQuality;
        "
        viewBox="0 0 369 461.25"
        x="0px"
        y="0px"
        fill-rule="evenodd"
        clip-rule="evenodd"
      >
        <g>
          <path
            d="M184 0c102,0 185,83 185,184 0,102 -83,185 -185,185 -101,0 -184,-83 -184,-185 0,-101 83,-184 184,-184zm8 71c17,0 30,14 30,30 -1,17 -14,30 -30,30 -17,0 -30,-14 -30,-30 0,-17 14,-30 30,-30zm43 202c-9,33 -97,36 -91,-9 4,-30 10,-59 15,-88 3,-19 -9,-13 -20,-17 -7,-3 -7,-12 2,-14 11,-3 50,-1 63,-1 7,0 11,4 12,11 0,6 -1,11 -2,17 -5,28 -12,58 -16,86 0,6 1,17 10,16 9,0 13,-4 20,-7 4,-2 8,1 7,6z"
          />
        </g>
      </svg>
    </div>
    <div class="ux-scroll-slow">
      <div>
        <p>
          Due to staff shortages the 29 service &#64;15:06 from Workington bus
          station to Whitehaven will not operate sorry for any inconvenience
          caused
        </p>
      </div>
    </div>
    <div class="ux-stagecoach-logo">
      <svg
        width="200px"
        viewBox="0 0 250 58"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g
          id="Page-1"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
        >
          <g id="Apple-TV" transform="translate(-1643.000000, -1000.000000)">
            <g id="Group-8" transform="translate(0.000000, 975.000000)">
              <g
                id="ux-stagecoach"
                transform="translate(1643.000000, 25.000000)"
              >
                <path
                  d="M75.73,23.8670506 C75.475,22.4195812 74.303,20.1734729 71.03,20.1734729 C68.584,20.1734729 66.988,21.7626527 66.988,23.4986038 C66.988,24.9460733 67.897,26.0848168 69.788,26.4532635 L73.4,27.1557417 C78.089,28.0798953 80.612,31.1833508 80.612,34.8769284 C80.612,38.9045375 77.298,42.9685864 71.287,42.9685864 C64.44,42.9685864 61.415,38.4966143 61.016,34.7696335 L65.677,33.5144852 C65.895,36.1006981 67.677,38.4267714 71.323,38.4267714 C74.023,38.4267714 75.518,37.0663525 75.518,35.2058988 C75.518,33.6875742 74.389,32.5184642 72.387,32.1044677 L68.78,31.3645375 C64.664,30.515288 62.004,27.8217801 62.004,23.8650262 C62.004,19.2088307 66.122,15.6660733 71.004,15.6660733 C77.27,15.6660733 79.675,19.5074346 80.258,22.4631065 L75.73,23.8670506 Z"
                  id="Path"
                  fill-rule="nonzero"
                ></path>
                <path
                  d="M89.173,24.2456195 L92.779,24.2456195 L92.779,28.6052356 L89.173,28.6052356 L89.173,36.2150785 C89.173,37.8042583 89.901,38.3215009 91.287,38.3215009 C91.7881644,38.3261721 92.2883725,38.2762868 92.779,38.1727051 L92.779,42.2296684 C92.343,42.4159162 91.468,42.6750436 90.048,42.6750436 C86.548,42.6750436 84.365,40.5676091 84.365,37.0582548 L84.365,28.5971379 L81.122,28.5971379 L81.122,24.2446073 L82.039,24.2446073 C83.939,24.2446073 84.809,22.9874346 84.809,21.3628272 L84.809,18.8069808 L89.173,18.8069808 L89.173,24.2456195 Z"
                  id="Path"
                  fill-rule="nonzero"
                ></path>
                <path
                  d="M103.48,38.9359162 C105.994,38.9359162 107.889,36.8294939 107.889,33.5033508 C107.889,30.1772077 106.036,28.2195812 103.489,28.2195812 C100.9,28.2195812 99,30.1772077 99,33.504363 C99,36.7930541 100.859,38.9369284 103.484,38.9369284 L103.48,38.9359162 Z M107.926,40.1910646 C107.159,41.9270157 105.303,43.1841885 102.897,43.1841885 C97.616,43.1841885 94.118,39.0087958 94.118,33.5033508 C94.118,28.1841536 97.543,23.9733333 102.753,23.9733333 C105.959,23.9733333 107.453,25.7102967 107.889,26.7437696 L107.889,24.495637 L112.577,24.495637 L112.577,39.3752182 C112.577,40.9998255 112.687,42.2569983 112.724,42.6639092 L108.1,42.6639092 C107.986073,41.9177064 107.928905,41.1637521 107.929,40.4086911 L107.926,40.1910646 Z"
                  id="Shape"
                ></path>
                <path
                  d="M127.967,33.0255846 C127.967,30.2187086 126.073,28.4442932 123.741,28.4442932 C121.336,28.4442932 119.441,30.2187086 119.441,33.0255846 C119.441,35.8699127 121.227,37.6433159 123.741,37.6433159 C126.218,37.6433159 127.967,35.8324607 127.967,33.0255846 Z M118.933,42.4827225 C119.261,44.477801 120.827,45.9191972 123.122,45.9191972 C126.179,45.9191972 127.893,44.3684817 127.893,40.8581152 L127.893,39.5270506 C127.166,40.7072949 125.493,41.8551483 122.904,41.8551483 C118.132,41.8551483 114.561,38.1231065 114.561,33.0255846 C114.561,28.22363 117.985,24.1595812 122.904,24.1595812 C125.745,24.1595812 127.388,25.4157417 128.004,26.6395113 L128.004,24.495637 L132.666,24.495637 L132.666,40.7153927 C132.666,45.7035951 130.016,50.2474346 123.266,50.2474346 C118.35,50.2474346 115.066,47.1470157 114.566,43.6680279 L118.933,42.4827225 Z"
                  id="Shape"
                ></path>
                <path
                  d="M147.529,31.5082723 C147.455,29.6994415 146.289,27.9260384 143.521,27.9260384 C141.008,27.9260384 139.621,29.8492496 139.514,31.5082723 L147.529,31.5082723 Z M152.046,37.4580803 C151.135,40.5959511 148.293,43.2216405 143.892,43.2216405 C138.974,43.2216405 134.638,39.63637 134.638,33.504363 C134.638,27.7033508 138.864,23.9348691 143.454,23.9348691 C148.99,23.9348691 152.307,27.5181152 152.307,33.3555672 C152.307,34.0580454 152.233,34.8030366 152.233,34.8738918 L139.41,34.8738918 C139.52,37.2738569 141.524,39.0087958 143.927,39.0087958 C146.185,39.0087958 147.427,37.8629668 148.004,36.2383595 L152.046,37.4580803 Z"
                  id="Shape"
                ></path>
                <path
                  d="M158.884,33.5772426 C158.884,36.8669459 160.998,38.7132286 163.475,38.7132286 C165.952,38.7132286 167.191,37.059267 167.592,35.6472251 L171.854,37.0936824 C171.054,40.1222339 168.246,43.2277138 163.475,43.2277138 C158.193,43.2277138 154.041,39.1636649 154.041,33.5843281 C154.041,27.9695637 158.118,23.9419546 163.33,23.9419546 C168.21,23.9419546 170.98,27.0079581 171.744,30.0739616 L167.409,31.5517976 C166.972,30.038534 165.843,28.4857941 163.438,28.4857941 C160.961,28.4857941 158.884,30.2966492 158.884,33.5843281"
                  id="Path"
                  fill-rule="nonzero"
                ></path>
                <path
                  d="M187.309,33.3241885 C187.309,29.888726 185.124,28.1568237 182.755,28.1568237 C180.386,28.1568237 178.2,29.8927749 178.2,33.3241885 C178.2,36.7232112 180.385,38.4925654 182.753,38.4925654 C185.121,38.4925654 187.309,36.7566143 187.309,33.3241885 Z M192.152,33.3241885 C192.152,38.9055497 188.108,42.9685864 182.752,42.9685864 C177.396,42.9685864 173.352,38.9045375 173.352,33.3241885 C173.352,27.7104363 177.396,23.6828272 182.752,23.6828272 C188.108,23.6828272 192.152,27.7104363 192.152,33.3241885 Z"
                  id="Shape"
                ></path>
                <path
                  d="M203.043,38.6828621 C205.558,38.6828621 207.452,36.5764398 207.452,33.2502967 C207.452,29.9241536 205.593,27.9665271 203.043,27.9665271 C200.458,27.9665271 198.558,29.9241536 198.558,33.2482723 C198.558,36.5369634 200.417,38.6808377 203.043,38.6808377 L203.043,38.6828621 Z M207.488,39.9380105 C206.722,41.6739616 204.865,42.9311344 202.462,42.9311344 C197.178,42.9311344 193.683,38.7557417 193.683,33.2502967 C193.683,27.9310995 197.105,23.7202792 202.315,23.7202792 C205.521,23.7202792 207.003,25.4572426 207.452,26.4907155 L207.452,24.2456195 L212.14,24.2456195 L212.14,39.1252007 C212.14,40.749808 212.25,42.0069808 212.287,42.4138918 L207.66,42.4138918 C207.542394,41.6679761 207.481548,40.9140203 207.478,40.1586736 L207.488,39.9380105 Z"
                  id="Shape"
                ></path>
                <path
                  d="M218.854,33.3241885 C218.854,36.6138918 220.966,38.4601745 223.445,38.4601745 C225.924,38.4601745 227.158,36.8062129 227.56,35.394171 L231.822,36.8446771 C231.022,39.8732286 228.216,42.9787086 223.445,42.9787086 C218.161,42.9787086 214.009,38.9146597 214.009,33.3353229 C214.009,27.7205585 218.086,23.6929494 223.298,23.6929494 C228.19,23.6929494 230.948,26.7589529 231.712,29.8249564 L227.372,31.296719 C226.934,29.7834555 225.805,28.2307155 223.402,28.2307155 C220.923,28.2307155 218.848,30.0415707 218.848,33.3282373"
                  id="Path"
                  fill-rule="nonzero"
                ></path>
                <path
                  d="M238.487,42.4118674 L233.642,42.4118674 L233.642,15.6660733 L238.487,15.6660733 L238.487,25.7528098 C239.653,24.3488656 241.62,23.7577312 243.333,23.7577312 C247.886,23.7577312 250,26.9694939 250,30.9616754 L250,42.4118674 L245.155,42.4118674 L245.155,31.8119372 C245.155,29.7794066 244.17,28.1892147 241.839,28.1892147 C239.8,28.1892147 238.597,29.7419546 238.487,31.7370332 L238.487,42.4118674 Z"
                  id="Path"
                  fill-rule="nonzero"
                ></path>
                <path
                  d="M28.594,40.0635388 C24.1716871,40.0704876 20.1809981,37.3793649 18.4838841,33.2457648 C16.7867701,29.1121647 17.7176936,24.3507256 20.8423101,21.1830106 C23.9669267,18.0152955 28.6694454,17.0655891 32.7557939,18.7769995 C36.8421425,20.4884098 39.5070056,24.523657 39.5070056,29 C39.5099187,31.932153 38.3616396,34.7453125 36.3149112,36.8202718 C34.2681828,38.8952311 31.490766,40.0619156 28.594,40.0635388 L28.594,40.0635388 Z M28.594,0 C12.827,0 0,13.0100175 0,29 C0,44.9899825 12.827,58 28.594,58 C44.361,58 57.194,44.9889703 57.194,28.9989878 C57.194,13.0090052 44.362,0 28.594,0 Z"
                  id="Shape"
                  fill="#FFFFFF"
                ></path>
                <path
                  d="M4.7,16.8027923 C4.7,16.8027923 11.5,1.92321117 28.5,1.92321117 C41.6,1.92321117 51.5,10.425829 51.5,22.5724258 C51.5,32.2390925 43.575,41.5130192 32.781,41.5130192 C32.0857014,41.5180904 31.3907445,41.4802307 30.7,41.399651 C30.7,41.399651 41.3,40.6657941 41.3,28.9493892 C41.3,17.376719 32.4,8.40139616 21.2,8.40139616 C10,8.40139616 4.7,16.8027923 4.7,16.8027923 Z"
                  id="Path"
                  fill="#F9AE00"
                ></path>
                <path
                  d="M50.9,13.9685864 C50.9,13.9685864 55.3,20.1765096 55.3,28.8481675 C55.3,44.5375218 43.433,55.0645724 32.5,55.0645724 C21,55.0645724 13.3,45.5831414 13.3,35.5287958 C13.3,28.8147644 16.8,24.2931937 16.8,24.2931937 C16.8,24.2931937 16.1,26.506911 16.1,28.8481675 C16.1,39.0381501 24.733,43.0191972 32.2,43.0191972 C44.733,43.0191972 52.7,32.4243281 52.7,22.0663176 C52.7,17.1307504 50.9,13.9685864 50.9,13.9685864 Z"
                  id="Path"
                  fill="#0079C1"
                ></path>
                <path
                  d="M38.2,20.547993 C38.2,20.547993 33.8,9.61605585 21,9.61605585 C8.517,9.61605585 1.8,20.7504363 1.8,28.8481675 C1.8,43.0191972 13.013,55.9755672 28.1,55.9755672 C29.231,55.9755672 30.3,55.8743455 30.3,55.8743455 C30.3,55.8743455 23.617,55.8065271 18.5,50.6108202 C12.688,44.7085864 12,38.5148342 12,35.4275742 C12,26.1151832 18.983,16.1954625 28.5,16.1954625 C35.338,16.1954625 38.2,20.547993 38.2,20.547993 Z"
                  id="Path"
                  stroke="#FFFFFF"
                  stroke-width="0.5"
                  fill="#009879"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
  </div>

  <div
    class="ux-last-updated"
    *ngIf="showLastUpdated && liveBusDataProvider.lastFetchSuccess > 0"
  >
    Last updated {{ liveBusDataProvider.lastFetchSuccess | date : "HH:mm:ss" }}
  </div>
</div>
